import { Component, HostBinding, HostListener, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatDialog } from '@angular/material';
import { CurrentService, ProjectService } from 'dbweb-core';
import { SettingDialogComponent } from '../setting-dialog/setting-dialog.component';

@Component({
	selector: 'common-welcome',
	templateUrl: './welcome.component.html',
	styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent implements OnInit {
	@HostBinding('class.c-index-welcome') hostClass = true;

	@ViewChild('main', { static: true })
	mainDiv: ElementRef<HTMLElement>;

	isWrap = false;

	constructor(public prj: ProjectService, public cur: CurrentService, private dialog: MatDialog) {}

	ngOnInit() {
		const titleWidth = this.prj.projectLabel.length * 24;
		const welcomeWidth = this.mainDiv.nativeElement.getBoundingClientRect().width - 16;
		if (titleWidth > welcomeWidth) {
			this.isWrap = true;
		} else {
			this.isWrap = false;
		}
	}
	@HostListener('window:resize')
	onResize() {
		// event.target.innerWidth;
		const titleWidth = this.prj.projectLabel.length * 24;
		const welcomeWidth = this.mainDiv.nativeElement.getBoundingClientRect().width - 16;
		if (titleWidth > welcomeWidth) {
			this.isWrap = true;
		} else {
			this.isWrap = false;
		}
	}
	openSetting() {
		this.dialog.open(SettingDialogComponent, {
			width: '720px',
			height: '436px',
			autoFocus: false
		});
	}
}
